import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useEmpleados } from './useEmpleados';

import { crearEmpleado } from '../../services/empleado/empleadoService';
import FormularioPrincipal from './FormularioPrincipal';
import DialogosEmpleado from './DialogosEmpleado';
import ListaEmpleados from './ListaEmpleados';
import AddConfigModal from './AddConfigModal';
import { ScrollTop } from 'primereact/scrolltop';
import { puedeVerPorComponente } from '../../util/permisosPantalla';
const DatosEmpleados = () => {

    const logic = useEmpleados();
    const puedeVer = puedeVerPorComponente('DatosEmpleados');


    if (logic.view === 'list') {
        return (
            <div className="flex justify-content-center p-4">
                <Toast ref={logic.toast} />
                <ListaEmpleados
                    employees={logic.employeesList}
                    goToCreate={logic.goToCreate}
                    goToEdit={logic.goToEdit}
                    deleteEmployee={logic.deleteEmployee}
                    puedeVer={puedeVer}
                />
            </div>
        );
    }

    // Solo mostramos el boton "Guardar Datos" si el usuario puede editar la
    // identificacion (o la pantalla no declara el bloque -> modo backcompat).
    const mostrarGuardarDatos = puedeVer('BLOQUE_EDITAR_IDENTIFICACION');

    const header = (
        <div className="flex justify-content-between align-items-center p-3 border-bottom-1 surface-border bg-blue-50">
            <span className="text-xl font-bold text-700">
                {logic.isEditMode ? 'Empleados (Edición)' : 'Empleados (Nuevo Registro)'}
            </span>
            <div className="flex gap-2">
                {mostrarGuardarDatos && (
                    <Button icon="pi pi-save" label="Guardar Datos" className="p-button-primary" onClick={logic.saveEmployee} />
                )}
            </div>
        </div>
    );


    return (
        <div className="flex justify-content-center p-4">
            <Toast ref={logic.toast} />

            <Card header={header} className="w-full shadow-4" style={{ maxWidth: '1200px' }}>

                <FormularioPrincipal
                    // --- PERMISOS POR BLOQUE ---
                    puedeVer={puedeVer}
                    // --- CORE ---
                    formData={logic.formData}
                    handleChange={logic.handleChange}
                    toggleModal={logic.toggleModal}
                    isEditMode={logic.isEditMode}
                    goBack={logic.goBack}
                    unidadMedida={logic.unidadMedida}
                    handleUnitChange={logic.handleUnitChange}
                    handleGuardar={logic.saveEmployee}
                    listas={logic.listas}
                    handleAddConfig={logic.handleAddConfig}
                    validationErrors={logic.validationErrors}
                    loading={logic.generalLoading}

                    // --- PENSIÓN ---
                    tienePensionDoc={logic.tienePensionDoc}
                    savePensionDoc={logic.savePensionDoc}
                    deletePensionDoc={logic.deletePensionDoc}

                    // --- LICENCIAS (Aquí estaba el error) ---
                    licencias={logic.licencias}
                    licenciaLoading={logic.licenciaLoading}
                    openNewLicencia={logic.openNewLicencia}
                    openEditLicencia={logic.openEditLicencia} // <--- Esta faltaba
                    deleteLicencia={logic.deleteLicencia}     // <--- Esta faltaba
                    onLicenciaChange={logic.onLicenciaChange}
                    anulaLicencia = {logic.anulaLicencia}

                    // --- LIBRETAS ---
                    libretas={logic.libretas}
                    libretaLoading={logic.libretaLoading}
                    openNewLibreta={logic.openNewLibreta}
                    openEditLibreta={logic.openEditLibreta}
                    deleteLibreta={logic.deleteLibreta}
                    anulaLibreta={logic.anulaLibreta}

                    // --- TELÉFONOS ---
                    phones={logic.phones}
                    phoneLoading={logic.phoneLoading}
                    openNewPhone={logic.openNewPhone}
                    openEditPhone={logic.openEditPhone}
                    deletePhone={logic.deletePhone}
                    handleSetPrincipalPhone={logic.handleSetPrincipalPhone}

                    // --- OTROS MÓDULOS (Educación, Cuentas, Historia, etc.) ---
                    educacionList={logic.educacionList}
                    openNewEducacion={logic.openNewEducacion}
                    openEditEducacion={logic.openEditEducacion}
                    deleteEducacion={logic.deleteEducacion}
                    anulaEducacion={logic.anulaEducacion}

                    accounts={logic.accounts}
                    openNewAccount={logic.openNewAccount}
                    openEditAccount={logic.openEditAccount}
                    deleteAccount={logic.deleteAccount}
                    handleSetPrincipalAccount={logic.handleSetPrincipalAccount}

                    historialList={logic.historialList}
                    openNewHistorial={logic.openNewHistorial}
                    openEditHistorial={logic.openEditHistorial}
                    deleteHistorial={logic.deleteHistorial}
                    anulaHistorial={logic.anulaHistorial}

                    familiares={logic.familiares}
                    openNewFamiliar={logic.openNewFamiliar}
                    openEditFamiliar={logic.openEditFamiliar}
                    deleteFamiliar={logic.deleteFamiliar}

                    otrosDocsList={logic.otrosDocsList}
                    openNewOtrosDocs={logic.openNewOtrosDocs}
                    openEditOtrosDocs={logic.openEditOtrosDocs}
                    deleteOtrosDocs={logic.deleteOtrosDocs}
                    anulaOtrosDocs={logic.anulaOtrosDocs}

                    fotosList={logic.fotosList}
                    openNewFoto={logic.openNewFoto}
                    deleteFoto={logic.deleteFoto}
                    openGallery={logic.openGallery}

                    ubicacionesList={logic.ubicacionesList}
                    openNewUbicacion={logic.openNewUbicacion}
                    openEditUbicacion={logic.openEditUbicacion}
                    deleteUbicacion={logic.deleteUbicacion}
                    ubicacionLoading={logic.ubicacionLoading}
                    handleSetPrincipalUbicacion={logic.handleSetPrincipalUbicacion}


                    experiencias={logic.experiencias}
                    openNewExperiencia={logic.openNewExperiencia}
                    openEditExperiencia={logic.openEditExperiencia}
                    deleteExperiencia={logic.deleteExperiencia}
                    experienciaLoading={logic.experienciaLoading}


                    generarReporteExpediente={logic.generarReporteExpediente}
                    reporteLoading={logic.reporteLoading}
                    datosPuesto={logic.datosPuesto}

                    resetCodigoUnico={logic.resetCodigoUnico}

                />

                <DialogosEmpleado

                    {...logic}
                    handleAddConfig={logic.handleAddConfig}

                />

                <AddConfigModal
                    visible={logic.addConfigDialog}
                    onHide={() => logic.setAddConfigDialog(false)}
                    configCabCode={logic.currentConfigCode}
                    onSuccess={logic.onConfigSaved}
                />

                <ScrollTop threshold={200} icon="pi pi-arrow-up" />

            </Card>
        </div>
    );
};

export default DatosEmpleados;